module.exports = __webpack_public_path__ + "static/media/素咖哩雞肉.9595f3e8.jpg";